export default __webpack_public_path__ + "static/media/goopter-ecommerce-off-premise-operations.df5bd0f8.png";